import { Dialog, DialogContent, DialogTitle, Link, List, ListItemButton, ListItemText, Menu, MenuItem, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useState, type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const DOCS_BASE = "/docs";  // served from feature README files by the website spoke (CF-0097+)
const SHORTCUTS: [string, string][] = [["Ctrl/Cmd + K", "Global search"], ["?", "Keyboard shortcuts"], ["Esc", "Close dialogs"], ["Ctrl/Cmd + S", "Save the current form"]];

/** Help & support menu (CF-0028): contextual docs link, shortcuts, support, status, what's new. */
export function HelpMenu({ trigger }: { trigger: (open: (e: React.MouseEvent<HTMLElement>) => void) => ReactElement }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [shortcuts, setShortcuts] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const contextPath = location.pathname.replace(/^\/app\/?/, "").split("/").filter(Boolean).slice(0, 2).join("/") || "home";
  return (
    <>
      {trigger((e) => setAnchor(e.currentTarget))}
      <Menu open={!!anchor} anchorEl={anchor} onClose={() => setAnchor(null)}>
        <MenuItem component={Link} href={`${DOCS_BASE}/${contextPath}`} target="_blank" rel="noopener" onClick={() => setAnchor(null)}>{t("help.docs")}</MenuItem>
        <MenuItem onClick={() => { setAnchor(null); setShortcuts(true); }}>{t("help.shortcuts")}</MenuItem>
        <MenuItem component={Link} href="mailto:support@cloudforge.local" onClick={() => setAnchor(null)}>{t("help.support")}</MenuItem>
        <MenuItem component={Link} href="/status" target="_blank" rel="noopener" onClick={() => setAnchor(null)}>{t("help.status")}</MenuItem>
        <MenuItem component={Link} href="/changelog" target="_blank" rel="noopener" onClick={() => setAnchor(null)}>{t("help.whatsNew")}</MenuItem>
      </Menu>
      <Dialog open={shortcuts} onClose={() => setShortcuts(false)}>
        <DialogTitle>{t("help.shortcuts")}</DialogTitle>
        <DialogContent>
          <Table size="small"><TableBody>
            {SHORTCUTS.map(([k, v]) => <TableRow key={k}><TableCell><kbd>{k}</kbd></TableCell><TableCell>{v}</TableCell></TableRow>)}
          </TableBody></Table>
          <List dense><ListItemButton component="a" href={`${DOCS_BASE}/${contextPath}`} target="_blank"><ListItemText primary="Open documentation for this page" /></ListItemButton></List>
        </DialogContent>
      </Dialog>
    </>
  );
}
